import React from "react";
import headerLogo from "../assets/website-header-transparent.png";
import "./Header.css";

export default function Header() {
  return (
    <div className="header">
      <div className="header-content">
        <img className="header-logo" src={headerLogo} alt="Header Logo" />
        <h1 className="header-title">
          <span className="job-text">Job</span>
          <span className="craft-text">Craft</span>
        </h1>
      </div>
    </div>
  );
}
